import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useState,
} from 'react';
import { MaintenancePaymentMethod } from 'models/enums';

/**
 * `paymentMethod` includes `null` because that is what the provider below seeds
 * it with — "no method chosen yet" is the initial state, and the type omitting
 * it was simply wrong.
 */
type PaymentMethodContextType = {
  paymentMethod: keyof typeof MaintenancePaymentMethod | null;
  setPaymentMethod: Dispatch<
    SetStateAction<keyof typeof MaintenancePaymentMethod | null>
  >;
};

const PaymentMethodContext = createContext<PaymentMethodContextType | null>(
  null,
);

type Props = {
  children: ReactNode;
};

export const PaymentMethodProvider = ({ children }: Props) => {
  // Typed rather than reseeded: `useState(null)` gave the state the type `null`,
  // so it could never hold a method. The initial value is unchanged.
  const [paymentMethod, setPaymentMethod] = useState<
    keyof typeof MaintenancePaymentMethod | null
  >(null);

  return (
    <PaymentMethodContext.Provider value={{ paymentMethod, setPaymentMethod }}>
      {children}
    </PaymentMethodContext.Provider>
  );
};
